module.exports = __webpack_public_path__ + "media/images/navbar-alert-icon-a55766f7d585fe1dcfd21f306c4355a0.svg";